import React from "react";
import LeaderboardTableRows from "./LeaderboardTableRows";
import { Participants } from "../../types/cloudFunctions/LeaderBoard";
import { Box, Flex, Spinner } from "@radix-ui/themes";

const LeaderboardParticipantsTable: React.FunctionComponent<{
  items: Participants[] | undefined;
  observerRef?: (node?: Element | null | undefined) => void;
  observerRefAll?: (node?: Element | null | undefined) => void;
  children: React.ReactNode;
  inViewIndex?: number;
  loading: boolean;
  game: string;
  maxItems?: number;
}> = ({ items, inViewIndex, game, maxItems }) => {
  const displayedItems = items
    ? maxItems
      ? items.slice(0, maxItems)
      : items
    : [];

  const filteredItems = displayedItems.filter(
    (item) => item.userChallengeData.points !== 0
  );

  return (
    <Flex direction="column" gap="3">
      {!filteredItems && <Spinner />}
      {filteredItems.map((item, index) => {
        return (
          <Box key={item?.profile.uid}>
            <Box>
              <LeaderboardTableRows
                rank={index + 1}
                logo={item?.profile.profileLogoUrl}
                name={[item?.profile.userName, item?.profile.fullName]}
                points={
                  item?.userChallengeData.points !== null
                    ? item?.userChallengeData.points
                    : "-"
                }
                slug={item?.profile.slug}
                game={game}
                pointsType={item.userChallengeData.pointsType}
              />
            </Box>
          </Box>
        );
      })}
    </Flex>
  );
};

export default LeaderboardParticipantsTable;
